import { useState, useEffect } from 'react';
import { adminStore } from '../../../store/adminStore';
import { communityPosts } from '../../../mocks/community';

const ROLE_LABELS = { student: 'Học sinh', teacher: 'Giáo viên', parent: 'Phụ huynh' };
const ROLE_COLORS = {
  student: 'bg-yellow-100 text-yellow-700',
  teacher: 'bg-orange-100 text-orange-600',
  parent: 'bg-green-100 text-green-700',
};

export default function CommunityEditor() {
  const [hiddenPostIds, setHiddenPostIds] = useState<string[]>([]);

  const refresh = () => {
    setHiddenPostIds(adminStore.getStore().hiddenPostIds);
  };

  useEffect(() => {
    refresh();
    const handler = () => refresh();
    window.addEventListener('bahnar-admin-updated', handler);
    return () => window.removeEventListener('bahnar-admin-updated', handler);
  }, []);

  const handleToggle = (postId: string) => {
    if (hiddenPostIds.includes(postId)) {
      adminStore.restorePost(postId);
    } else {
      adminStore.hidePost(postId);
    }
    refresh();
  };

  const hiddenCount = hiddenPostIds.filter((id) =>
    communityPosts.some((p) => p.id === id)
  ).length;

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div>
          <h2 className="font-bold text-gray-800">Quản lý bài đăng Cộng đồng</h2>
          <p className="text-xs text-gray-400">Ẩn/hiện các bài đăng trên trang cộng đồng</p>
        </div>
        {hiddenCount > 0 && (
          <span className="text-xs bg-red-50 text-red-400 px-3 py-1.5 rounded-full font-medium">
            {hiddenCount} bài đang bị ẩn
          </span>
        )}
      </div>

      <div className="space-y-3">
        {communityPosts.map((post) => {
          const isHidden = hiddenPostIds.includes(post.id);
          return (
            <div
              key={post.id}
              className={`bg-white rounded-2xl p-5 flex items-start gap-4 transition-all ${
                isHidden ? 'opacity-50' : ''
              }`}
            >
              <img
                src={post.authorAvatar}
                alt={post.authorName}
                className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="font-bold text-sm text-gray-800">{post.authorName}</span>
                  <span
                    className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      ROLE_COLORS[post.authorRole]
                    }`}
                  >
                    {ROLE_LABELS[post.authorRole]}
                  </span>
                  {isHidden && (
                    <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-400 rounded-full">
                      Đã ẩn
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-500 line-clamp-2 mb-1">{post.content}</p>
                <p className="text-xs text-gray-300">{post.createdAt}</p>
              </div>

              <div className="flex flex-col items-end gap-2 flex-shrink-0">
                {post.image && (
                  <img
                    src={post.image}
                    alt=""
                    className="w-20 h-14 object-cover rounded-xl"
                  />
                )}
                <button
                  onClick={() => handleToggle(post.id)}
                  className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium cursor-pointer whitespace-nowrap transition-all ${
                    isHidden
                      ? 'bg-orange-50 text-orange-500 hover:bg-orange-100'
                      : 'bg-gray-50 text-gray-500 hover:bg-red-50 hover:text-red-400'
                  }`}
                >
                  <i className={isHidden ? 'ri-eye-line' : 'ri-eye-off-line'}></i>
                  {isHidden ? 'Hiện bài' : 'Ẩn bài'}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {communityPosts.length === 0 && (
        <div className="bg-white rounded-2xl p-10 text-center">
          <p className="text-sm text-gray-400">Chưa có bài đăng nào.</p>
        </div>
      )}
    </div>
  );
}
